<template>
  <section class="content-block small-padding">
    <transition name="slide-fade-delay">
      <div
        v-if="active"
        class="block has-white-background"
      >
        <h1 class="title">
          {{ $t("general.label.tour") }}
        </h1>

        <div class="summary inner-block is-flex">
          <div class="col-2">
            <h1 class="title reset">
              <strong>{{ $t("general.label.tour") }}:</strong> <span class="font-weight-adj"> {{
                show_selectedType
              }}</span>
            </h1>
            <h1 class="title reset">
              <strong>{{ $t("general.label.date") }}:</strong> <span class="font-weight-adj"> {{
                show_selectedDate
              }}</span>
            </h1>
          </div>
          <div class="col-2">
            <h1
              v-if="this.$store.state.selectedType == 1 || this.$store.state.selectedType == 2"
              class="title reset"
            >
              <strong>{{ $t("sequenceLabels.tour.1") }}:</strong> <span
                class="font-weight-adj"
              > {{
                $t('datenView.label.formattedDate', {date: show_selectedDate, time: show_selectedTime_Bergfahrt})
              }}</span>
            </h1>
            <h1
              v-if="this.$store.state.selectedType == 1 || this.$store.state.selectedType == 3"
              class="title reset"
            >
              <strong>{{ $t("sequenceLabels.tour.3") }}:</strong> <span
                class="font-weight-adj"
              > {{
                $t('datenView.label.formattedDate', {date: show_selectedDate, time: show_selectedTime_Talfahrt})
              }}</span>
            </h1>
            <h1
              v-if="this.$store.state.selectedType > 3"
              class="title reset"
            >
              <strong>{{ $t("sequenceLabels.tour." + this.$store.state.selectedType) }}:</strong> <span
                class="font-weight-adj"
              > {{
                $t('datenView.label.formattedDate', {date: show_selectedDate, time: show_selectedTime_subset})
              }}</span>
            </h1>
          </div>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import moment from 'moment'

export default {
  name: 'Anzahl',
  data() {
    return {
      active: false
    }
  },
  computed: {
    show_selectedType() {
      if (this.$store.state.selectedType == 1) {
        return this.$t('general.label.tourAscentDescent')
      } else if (this.$store.state.selectedType == 2) {
        return this.$t('sequenceLabels.tour.1')
      } else if (this.$store.state.selectedType == 3) {
        return this.$t('sequenceLabels.tour.3')
      } else if (this.$store.state.selectedType > 3) {
        return this.$t('sequenceLabels.tour.' + this.$store.state.selectedType)
      } else {
        return this.$t('datenView.label.noTourSelected')
      }
    },
    show_selectedDate() {
      if (this.$store.state.selectedDate) {
        if (this.$store.state.selectedType > 3) {
          return this.$store.state.subset_Slot_Timestamp;
        }

        return moment(this.$store.state.selectedDate).format('DD.MM.YYYY')
      } else {
        return this.$t('datenView.label.noDateSelected')
      }
    },
    show_selectedTime_Bergfahrt() {
      if (this.$store.state.fetch_GET_Content_Bergfahrt.length === 1) {
        return '07:50-16:50';
      }
      if (this.$store.state.bergfahrt_Slot_Time) {
        return this.$store.state.bergfahrt_Slot_Time
      } else {
        return this.$t('datenView.label.noAscentAvailable')
      }
    },
    show_selectedTime_Talfahrt() {
      if (this.$store.state.fetch_GET_Content_Talfahrt.length === 1) {
        return '08:10-17:10';
      } else if (this.$store.state.talfahrt_Slot_Time) {
        return this.$store.state.talfahrt_Slot_Time
      } else {
        return this.$t('datenView.label.noDescentAvailable')
      }
    },
    show_selectedTime_subset() {
      if (this.$store.state.subset_Slot_Time) {
        return this.$store.state.subset_Slot_Time
      } else {
        return this.$t('sequenceLabels.notAvailable.' + this.$store.state.selectedType)
      }
    }
  },
  mounted() {
    this.active = true
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.title {
  &.reset {
    text-transform: initial !important;
    font-weight: 100;
  }

  strong {
    font-weight: bold;
  }
}

.font-weight-adj {
  font-weight: 400;
}

.summary {
  margin-top: 1.2rem;
}
</style>
